import React, { Component } from 'react';
import setCookie from '../../cookie/setCookie';
import { FormattedMessage,   injectIntl} from 'react-intl';

const divStyle = {
  WebkitTransition: 'all', // note the capital 'W' here
  msTransition: 'all' ,// 'ms' is the only lowercase vendor prefix
  float:'right',
  marginRight:'10px'
};


class StudioContestPopup extends Component{

  render() {
    const contestForm = this.props.intl.locale === 'ko' ?
      {
        url : 'http://bit.ly/2uMWuz1',
        img : require('../../img/event/studio_contest_3_ko.jpg')
      } :
      {
        url : 'https://forms.gle/vLVuch75FbHdo72K7',
        img : require('../../img/event/studio_contest_3_en.jpg')
      };
      return (
        <div id="div_laypopup" style={{height:'100%'}}>
            <div style={{width:'100%', display: 'flex', justifyContent: 'center'}}>
              <img src={contestForm.img} width="100%" height="100%" alt="" onClick={() => window.open(contestForm.url, '_blank')} style={{cursor:'pointer', maxWidth: 470}}/>
            </div>
            <div style={divStyle}>
              <input id="check" type="checkbox" name="openDouble" onClick={this.closeWin}/>
              <label for="check">
                <FormattedMessage
                  id={'PopUp.closeWindow.text'}
                  defaultMessage={'Do not open this window for a day'}
                />
              </label>
            </div>
        </div>
      );
    }

     closeWin = () => {
      setCookie( 'studioContestPopup', 'done', 1);
      window.close();
    }

}//end class

  
StudioContestPopup = injectIntl(StudioContestPopup);
export default StudioContestPopup;
